{
  "name": "alive-angular",
  "version": "3.4.28",
  "scripts": {
    "ng": "ng",
    "start": "npm run deployFixes && ng serve --port=4567 --host=0.0.0.0",
    "start:fr": "npm run deployFixes && ng serve --port=4567 --host=0.0.0.0 --configuration=fr",
    "deployFixes": "node deployFixes.mjs",
    "b": "npm run buildprod",
    "bd": "npm run buildprod && npm run deployprod",
    "build": "npm run deployFixes && ng build",
    "buildprod": "rm -r ./dist && npm run deployFixes && npm run generate:sitemaps && npm run generate:robots && npx createAngularStaticHashes --staticAssetsPath=src/assets --globPattern=/**/config.json && npm run buildprod_en && npm run buildprod_fr && npm run buildprod_es",
    "deployprod": "npm run sentry:sourcemaps && npm run sentry:sourcemaps:remove && node deployNonIndexFiles.js",
    "deployprodindex": "node deployIndexFiles.js && node --env-file=.env appUpdate.js",
    "bdtest": "npm run buildTest && npm run deployTest",
    "buildTest": "rm -r ./dist && npm run deployFixes && npm run generate:sitemaps && npm run generate:robots && npx createAngularStaticHashes --staticAssetsPath=src/assets --globPattern=/**/config.json && npm run buildtest_en && npm run buildtest_fr && npm run buildtest_es",
    "deployTest": "node deployTestFiles.js",
    "buildprod_en": "ng build -c=production --deploy-url https://livestatic.athletic.net/ && node_modules/.bin/gulp b --locale en",
    "buildprod_fr": "ng build -c=production,fr --deploy-url https://livestatic.athletic.net/fr/ && node_modules/.bin/gulp b --locale fr",
    "buildprod_es": "ng build -c=production,es --deploy-url https://livestatic.athletic.net/es/ && node_modules/.bin/gulp b --locale es",
    "buildtest_en": "ng build -c=production && node_modules/.bin/gulp b --locale en",
    "buildtest_fr": "ng build -c=production,fr && node_modules/.bin/gulp b --locale fr",
    "buildtest_es": "ng build -c=production,es && node_modules/.bin/gulp b --locale es",
    "generate:sitemaps": "node generateSiteMaps.js",
    "generate:robots": "node generateRobotsTxt.js",
    "extracti18n": "ng extract-i18n --out-file src/locale/messages.xlf && npx prettier src/locale/messages.xlf --write --plugin=@prettier/plugin-xml",
    "sentry:sourcemaps": "sentry-cli releases new --org spikefalcon --project athletic-live-angular $npm_package_version && sentry-cli sourcemaps inject --release=$npm_package_version --org spikefalcon --project athletic-live-angular ./dist/alive-angular/browser && sentry-cli sourcemaps upload --release=$npm_package_version --org spikefalcon --project athletic-live-angular ./dist/alive-angular/browser",
    "sentry:sourcemaps:remove": "rm -r dist/alive-angular/browser/*.map",
    "watch": "npm run deployFixes && ng build --watch --configuration development",
    "format": "prettier --write '**/?(.)*.{css,scss,js,ts,tsx,json,yaml,yml,html}'",
    "lint:format": "prettier --check '**/?(.)*.{css,scss,js,ts,tsx,json,yaml,yml,html}'",
    "prepare": "husky",
    "---unused/deprecated commands below---": "",
    "buildProdSingleSite": "npm run deployFixes && npx createAngularStaticHashes --staticAssetsPath=src/assets --globPattern=/**/config.json && ng build -c=production && node_modules/.bin/gulp b",
    "deployProdSingleSite": "npm run sentry:sourcemaps && npm run sentry:sourcemaps:remove && rsync --exclude=\"{'index.html'}\" -a dist/alive-angular/browser/ admin@web21:/srv/www/trackmeet.io/htdocs/dist_new_qld && rsync --exclude=\"{'index.html'}\" -a dist/alive-angular/browser/ admin@107.170.36.19:/srv/www/trackmeet.io/htdocs/dist_new_qld && rsync --exclude=\"{'index.html'}\" -a dist/alive-angular/browser/ admin@192.241.173.6:/srv/www/trackmeet.io/htdocs/dist_new_qld",
    "deployProdSingleSiteIndex": "rsync dist/alive-angular/browser/index.html admin@web21:/srv/www/trackmeet.io/htdocs/dist_new_qld/index.html && rsync dist/alive-angular/browser/index.html admin@107.170.36.19:/srv/www/trackmeet.io/htdocs/dist_new_qld/index.html && rsync dist/alive-angular/browser/index.html admin@192.241.173.6:/srv/www/trackmeet.io/htdocs/dist_new_qld/index.html",
    "serve:ssr:alive-angular": "node dist/alive-angular/server/server.mjs",
    "mtr": "git checkout master && git pull origin master && git checkout release && git merge master"
  },
  "engines": {
    "node": "24.x",
    "npm": "^11.10"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.12",
    "@angular/cdk": "^21.2.12",
    "@angular/common": "^21.2.12",
    "@angular/compiler": "^21.2.12",
    "@angular/core": "^21.2.12",
    "@angular/forms": "^21.2.12",
    "@angular/platform-browser": "^21.2.12",
    "@angular/platform-browser-dynamic": "^21.2.12",
    "@angular/platform-server": "^21.2.12",
    "@angular/router": "^21.2.12",
    "@angular/ssr": "^21.2.12",
    "@athleticnet/athletic-live-api": "^21.0.0",
    "@athleticnet/athletic-live-api-models": "3.0.39",
    "@brightcove/player-loader": "^1.8.0",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.0.0",
    "@fortawesome/free-brands-svg-icons": "^7.0.0",
    "@fortawesome/pro-duotone-svg-icons": "^7.0.0",
    "@fortawesome/pro-light-svg-icons": "^7.0.0",
    "@fortawesome/pro-regular-svg-icons": "^7.0.0",
    "@fortawesome/pro-solid-svg-icons": "^7.0.0",
    "@fortawesome/sharp-regular-svg-icons": "^7.0.0",
    "@fortawesome/sharp-solid-svg-icons": "^7.0.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-select/ng-select": "^21.8.0",
    "@sentry/angular": "^10.53.1",
    "@sitelintcode/angular-static-assets-hash": "^0.0.28",
    "bootstrap": "^5.3.8",
    "express": "^5.2.1",
    "firebase": "^12.13.0",
    "jwt-decode": "^4.0.0",
    "luxon": "^3.7.2",
    "minimist": "^1.2.8",
    "ngx-cookie-service": "^21.0.0",
    "ngx-countdown": "^21.0.0",
    "rxjs": "~7.8.0",
    "swiper": "^12.1.4",
    "tslib": "^2.3.0",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular/build": "^21.2.12",
    "@angular/cli": "~21.2.12",
    "@angular/compiler-cli": "^21.2.12",
    "@angular/localize": "^21.2.12",
    "@prettier/plugin-xml": "^3.4.1",
    "@sentry/cli": "^3.4.2",
    "@types/express": "^5.0.6",
    "@types/luxon": "^3.3.2",
    "@types/node": "^24.0.0",
    "@types/video.js": "^7.3.46",
    "browser-sync": "^3.0.0",
    "gulp": "^5.0.1",
    "gulp-inject": "^5.0.5",
    "gulp-inject-string": "^1.1.2",
    "gulp-replace": "^1.1.4",
    "husky": "^9.0.11",
    "lint-staged": "^15.2.2",
    "prettier": "^3.8.3",
    "replace-in-file": "^8.4.0",
    "source-map-explorer": "^2.5.3",
    "typescript": "~5.9.3"
  },
  "lint-staged": {
    "*.{css,scss,js,ts,tsx,json,yaml,yml,html}": "prettier --write"
  },
  "allowScripts": {
    "@parcel/watcher@2.5.6": true,
    "fsevents@2.3.3": true,
    "fsevents@1.2.13": true,
    "//es5-ext has protestware install script against russia war crimes, legitimate software though": "",
    "es5-ext": false,
    "protobufjs@7.6.1": true,
    "lmdb@3.5.1": true,
    "msgpackr-extract@3.0.4": true,
    "esbuild@0.27.3": true,
    "@sentry/cli@3.4.3": true,
    "@firebase/util@1.15.1": true
  }
}
